const Calculate = (v:any, prop:any) => {

  v.availabilityPercent.value = v.availability.value/365 * 100
  v.opTime.value = v.availabilityPercent.value/100 * 24 *365.25
  v.recoveryPerY.value = v.opTime.value * ( v.throughput.value * v.headGrade.value / 100 ) * v.recovery.value/100

  v.cellsInCircuit.value = v.cellsPerLine.value * v.linesParallel.value
  v.proposedNumCellsInLine.value = Math.ceil(v.cellsPerLine.value/2)
  v.proposedNumCellsTotal.value = v.proposedNumCellsInLine.value * v.linesParallel.value

/*   if(v.launderType.value === 'other') {
    v.expectedShift.value = 0.75
  } else {
    v.expectedShift.value = 0.5
  } */

  // v.newRecovery.value = v.recovery.value + v.expectedShift.value / 100
  // v.newRecovery.value = (v.recovery.value  + v.expectedShift.value) / 100
  v.newRecovery.value = v.recovery.value + v.expectedShift.value
  v.newRecoveryPerY.value = v.opTime.value * ( v.throughput.value * v.headGrade.value / 100 ) * v.newRecovery.value/100
  v.newExtraRecovery.value = v.newRecoveryPerY.value - v.recoveryPerY.value

  const cellInfo = v.cellSizes.find((item:any) => {
    return item.volume === parseInt(v.cellSize.value)
  })
  const countryInfo = v.co2factors.find((item:any) => item.country === v.location.value)
  const energyInfo = v.energyConsumptions.find((item:any) => item.metal === v.material.value)
  // console.log({cellInfo,countryInfo,energyInfo})
  if(cellInfo) {
    v.blowerPowerBefore.value = v.proposedNumCellsTotal.value * cellInfo.powerPerCell
    v.blowerPowerAfter.value = v.blowerPowerBefore.value * (((100 - cellInfo.blowerPortion)/100) + (cellInfo.blowerSaving/100)*((100 - cellInfo.blowerPortion)/100))
    // const powerSavedPerCell =   cellInfo.powerPerCell * (cellInfo.blowerPortion / 100)* (cellInfo.blowerSaving / 100)
    const powerSavedPerCell =  cellInfo.powerPerCell * v.opTime.value * (cellInfo.blowerPortion / 100)* (cellInfo.blowerSaving / 100) /1000
    v.blowerPowerSaved.value = powerSavedPerCell
    v.blowerPowerSavedAnnual.value =  v.proposedNumCellsTotal.value * powerSavedPerCell

    if(countryInfo) {
      v.conversionFactor.value = countryInfo.factor
      v.blowerCO2SavedAnnual.value = v.proposedNumCellsTotal.value * countryInfo.factor * powerSavedPerCell
    }
  }

  v.extraTonnesAnnual.value = v.newRecoveryPerY.value - v.recoveryPerY.value
  if(energyInfo) {
    if(prop === 'material') {
      v.concentratorPower.value = energyInfo.consumption
    }
    v.powerSavedAnnualKwh.value = v.extraTonnesAnnual.value * v.concentratorPower.value
    v.powerSavedAnnualMwh.value = v.powerSavedAnnualKwh.value /1000
    if(prop === 'material'){
      v.materialPrize.value = energyInfo.prize
    }

    if(countryInfo) {
      v.co2SavedAnnual.value = v.powerSavedAnnualMwh.value * countryInfo.factor
    }
  }

  v.powerTotalSavedAnnual.value = v.blowerPowerSavedAnnual.value + v.powerSavedAnnualMwh.value
  v.co2TotalSavedAnnual.value = v.blowerCO2SavedAnnual.value + v.co2SavedAnnual.value

  if(cellInfo) {
    v.co2FootPrint.value = cellInfo.co2ToCL * v.proposedNumCellsTotal.value
    v.co2Payback.value = Math.round(v.co2FootPrint.value / v.co2TotalSavedAnnual.value *12)
  }

  v.cashIncrease.value = v.materialPrize.value * v.extraTonnesAnnual.value * (1 - (v.treatmentCharges.value / 100))
  v.costSavings.value = v.energyCost.value * v.powerTotalSavedAnnual.value * 1000

  v.cashIncrease.value += v.costSavings.value

  return v

}

export default Calculate